import type { TPAComponentProps } from '../../types';

export enum DotNavigationAnimation {
  Back = 'back',
  BackNext = 'back-next',
  Forward = 'forward',
  ForwardNext = 'forward-next',
}

export enum DotNavigationTheme {
  Light = 'light',
  Dark = 'dark',
}

export interface DotNavigationProps extends TPAComponentProps {
  currentIndex?: number;
  length?: number;
  onSelect?(index: number): any;
  showBorder?: boolean;
  theme?: DotNavigationTheme;
  'aria-label'?: string | string[];
  noOpacityTransition?: boolean;
}

export const enum DotNavigationSize {
  Normal = 'normal',
  Small = 'small',
  Tiny = 'tiny',
}

export interface DotNavigationState {
  savedCurrentIndex: number;
  animation: null | string;
}

export interface DotNavigationDotProps {
  key: number | string;
  checked?: boolean;
  size: 'normal' | 'small' | 'tiny';
  onChange: any;
  onKeyDown?: any;
  ariaLabel: null | string;
  /**
   * @deprecated
   * Will be removed in future version.
   * Do not use unless something is broken and you need a fix before a new version is released.   *
   */
  unstableHasInnerWrapper?: boolean;
}

export enum DotNavigationDataKeys {
  ShowBorder = 'data-show-border',
  Theme = 'data-theme',
  SavedCurrentIndex = 'data-current',
}

export enum DotNavigationDataHooks {
  Dot = 'dot',
  Input = 'hidden-radio',
}
